// Rosin-Tropfen laufen einmal nach, sobald sie ganz sichtbar sind.
const io = new IntersectionObserver((entries) => entries.forEach((e) => {
  if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target) }
}), { threshold: 1 })
const mount = (root) => root.querySelectorAll('[data-drip]:not(.is-in)').forEach((el) => io.observe(el))
mount(document)
// Im Theme-Editor kommen Sections nachtraeglich dazu
document.addEventListener('shopify:section:load', (e) => mount(e.target))
